import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.component';
import { LanguageComponent } from './language/language.component';
import { VideoRecordingComponent } from './video-recording/video-recording.component';
import { VerificationComponent } from './verification/verification.component';
import { HeaderComponent } from './header/header.component';
import { PivcCompleteComponent } from './pivc-complete/pivc-complete.component';
import { HttpClientModule } from '@angular/common/http';
import { LinkExpireComponent } from './link-expire/link-expire.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { GlobalErrorHandler } from './utility/global-error-handler';
import { DatePipe } from '@angular/common';
import { WebCamModule } from 'ack-angular-webcam';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    LanguageComponent,
    VideoRecordingComponent,
    VerificationComponent,
    HeaderComponent,
    PivcCompleteComponent,
    LinkExpireComponent,
    ContactUsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    WebCamModule
  ],
  providers: [{
    provide: ErrorHandler,
    useClass: GlobalErrorHandler
  },DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
